// Lightweight replacement for the old per-project WebGL scenes:
// a lazy-loaded image with a subtle CSS 3D tilt that follows the pointer.
const ProjectImage = ({ src, alt }) => {
    const onPointerMove = (event) => {
        if (event.pointerType !== 'mouse') return
        const el = event.currentTarget
        const rect = el.getBoundingClientRect()
        const x = (event.clientX - rect.left) / rect.width - 0.5
        const y = (event.clientY - rect.top) / rect.height - 0.5
        el.style.setProperty('--tilt-x', `${(-y * 8).toFixed(2)}deg`)
        el.style.setProperty('--tilt-y', `${(x * 8).toFixed(2)}deg`)
    }
    const onPointerLeave = (event) => {
        event.currentTarget.style.setProperty('--tilt-x', '0deg')
        event.currentTarget.style.setProperty('--tilt-y', '0deg')
    }

    return (
        <div className="project-image" onPointerMove={onPointerMove} onPointerLeave={onPointerLeave}>
            <img src={src} alt={alt} width="1200" height="600" loading="lazy" decoding="async" />
        </div>
    )
}

export default ProjectImage
